// src/services/estimateService.js
// Add this function to your existing estimateService.js file

export const generateEstimatePDF = async (estimateId) => {
    try {
      // Get the auth token
      const token = localStorage.getItem('token');
      
      // Make the API call to generate the PDF
      const response = await fetch(`${process.env.REACT_APP_API_URL}/estimate/${estimateId}/pdf`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (!response.ok) {
        throw new Error('Failed to generate PDF');
      }
      
      // Get the PDF as a blob
      const pdfBlob = await response.blob();
      
      // Create a URL for the blob
      const pdfUrl = URL.createObjectURL(pdfBlob);
      
      // Create a download link
      const downloadLink = document.createElement('a');
      downloadLink.href = pdfUrl;
      downloadLink.download = `estimate-${estimateId}.pdf`;
      
      // Append to the document, trigger click, and remove
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      
      // Clean up the URL object
      URL.revokeObjectURL(pdfUrl);
      
      return true;
    } catch (error) {
      console.error('Error generating PDF:', error);
      throw error;
    }
  };